module.exports = __webpack_public_path__ + "static/logo.6dc4912a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NavBar/Logo/logo.png
// module id = 778
// module chunks = 114276838955818